import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=5fa9b0ae&scoped=true&"
import script from "./BaseSection.vue?vue&type=script&lang=js&"
export * from "./BaseSection.vue?vue&type=script&lang=js&"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=5fa9b0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa9b0ae",
  null
  
)

export default component.exports